"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowMoreLink = exports.SideBarLink = void 0;
const styled_1 = require("./styled");
const react_1 = __importDefault(require("react"));
const SideBarLink = (_a) => {
    var { to, title } = _a, rest = __rest(_a, ["to", "title"]);
    return (react_1.default.createElement(styled_1.StyledLink, Object.assign({ href: to }, rest),
        react_1.default.createElement(styled_1.StyledLinkTitleWrapper, null, title),
        react_1.default.createElement(styled_1.StyledIcon, { size: "large", name: "open_in_new" })));
};
exports.SideBarLink = SideBarLink;
const ShowMoreLink = ({ onClick }) => {
    return (react_1.default.createElement(styled_1.LinkWrapper, null,
        react_1.default.createElement(styled_1.StyledLink, { onClick: onClick }, "Show more")));
};
exports.ShowMoreLink = ShowMoreLink;
